// localStorage persistence + pomocne funkce pro generovani cisla faktury.

const KEY_STATE = 'faktura:v1';
const KEY_COUNTER = 'faktura:counter';

/**
 * Nacte ulozenou fakturu z localStorage. Vrati null, pokud nic neni / je rozbita.
 * @returns {object|null}
 */
export function loadState() {
  try {
    const raw = localStorage.getItem(KEY_STATE);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

/**
 * Ulozi stav. Pri chybe (napr. plne uloziste) vrati false.
 * @param {object} state
 */
export function saveState(state) {
  try {
    localStorage.setItem(KEY_STATE, JSON.stringify(state));
    return true;
  } catch {
    return false;
  }
}

/** Smaze ulozenou fakturu. Counter zustava (cisla pokracuji). */
export function clearState() {
  try {
    localStorage.removeItem(KEY_STATE);
  } catch {
    // ignorujeme – nezpusobuje vypadek funkcnosti
  }
}

/**
 * Vrati nove cislo faktury ve formatu YYYYNNNN (rok + 4mistny poradnik).
 * Counter se resetuje s prelomem roku.
 */
export function nextInvoiceNumber() {
  const year = new Date().getFullYear();
  let counter = 0;
  let storedYear = year;
  try {
    const raw = localStorage.getItem(KEY_COUNTER);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed.counter === 'number') counter = parsed.counter;
      if (parsed && typeof parsed.year === 'number') storedYear = parsed.year;
    }
  } catch {
    counter = 0;
  }
  if (storedYear !== year) counter = 0;
  counter += 1;
  try {
    localStorage.setItem(KEY_COUNTER, JSON.stringify({ year, counter }));
  } catch {
    // ignorujeme – cislo stale vrati, jen ho neulozime
  }
  return `${year}${String(counter).padStart(4, '0')}`;
}

/**
 * Jednoduchy debounce wrapper, hodi se pro autosave.
 * @template {(...args: any[]) => any} F
 * @param {F} fn
 * @param {number} delay ms
 * @returns {(...args: Parameters<F>) => void}
 */
export function debounce(fn, delay) {
  let timer = null;
  return (...args) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      fn(...args);
    }, delay);
  };
}
